import en from "./opay.frontend/en.json";
import frCA from "./opay.frontend/fr-CA.json";
import fr from "./opay.frontend/fr.json";
import nl from "./opay.frontend/nl.json";
export const messages = {
    en,
    fr,
    nl,
    "fr-CA": frCA,
};
